import getRedirectToLoginUri from 'utils/getRedirectToLoginUri';

function RedirectToLogin (props) {
  window.location = getRedirectToLoginUri();

  return null;
}

export default RedirectToLogin;
